import styled from '@emotion/styled';

export const ActiveLabel = styled.div`
  display: inline-block;
  margin-left: 5px;
  font-weight: 700;
  color: ${(props) => props.theme.color.blue.default};
`;
